import { unitMapping, type Unit } from '#src/lib/style.ts';

type Props = {
  size?: Unit;
  color?: string;
  className?: string;
};

export const S27 = ({ size = 2, color = 'currentColor', className }: Props) => {
  return (
    <svg
      style={{
        width: unitMapping[size],
      }}
      viewBox="0 0 24.2148 15.4062"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M24.2148 11.7764L19.7725 15.4062H0V3.63867L3.83301 0H24.2148V11.7764ZM8.9375 1.48047C6.7968 1.48047 5.91423 2.16677 5.91406 3.73535V5.51758H7.59766V2.83691H10.2773V6.1709L5.91406 9.27637V13.5088H11.9609V12.2178H7.59766V9.92969L11.9609 6.80859V3.73535C11.9608 2.16682 11.078 1.48051 8.9375 1.48047ZM13.2236 1.5791V2.88672H17.2109L14.2041 13.5088H15.9688L18.9922 2.88672V1.5791H13.2236Z"
        fill={color}
      />
    </svg>
  );
};
